/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './notification.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../app/notification/notification.component';
import * as import3 from '../../../app/notification/notification.service';
const styles_NotificationComponent:any[] = [import0.styles];
export const RenderType_NotificationComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_NotificationComponent,
  data: {}
}
);
export function View_NotificationComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),23,'section',[[
        'class',
        'notification'
      ]
    ],[
      [
        2,
        'notification_visible',
        (null as any)
      ]
      ,
      [
        2,
        'notification_success',
        (null as any)
      ]
      ,
      [
        2,
        'notification_failure',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'notification__wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'notifications__message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'notification__title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'notification__text'
      ]
      ,
      [
        'id',
        'sn-content'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'figure',[[
        'class',
        'notification__icon'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,':svg:svg',[
      [
        'class',
        'notification__svg'
      ]
      ,
      [
        'fill',
        '#ffffff'
      ]
      ,
      [
        'height',
        '24'
      ]
      ,
      [
        'viewBox',
        '0 0 24 24'
      ]
      ,
      [
        'width',
        '24'
      ]
      ,
      [
        'xmlns',
        'http://www.w3.org/2000/svg'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,':svg:path',[
      [
        'd',
        'M0 0h24v24H0z'
      ]
      ,
      [
        'fill',
        'none'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,':svg:path',[[
        'd',
        'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import2.NotificationComponent = v.component;
    const currVal_0:any = co.show;
    const currVal_1:boolean = !co.isError;
    const currVal_2:any = co.isError;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = co.title;
    ck(v,7,0,currVal_3);
    const currVal_4:any = co.message;
    ck(v,10,0,currVal_4);
  });
}
function View_NotificationComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-notification',([] as any[]),(null as any),(null as any),(null as any),View_NotificationComponent_0,RenderType_NotificationComponent)),
    import1.ɵdid(245760,(null as any),0,import2.NotificationComponent,[
      import3.NotificationServiceBus,
      import1.NgZone
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NotificationComponentNgFactory:import1.ComponentFactory<import2.NotificationComponent> = import1.ɵccf('app-notification',import2.NotificationComponent,View_NotificationComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/notification/notification.component.ngfactory.ts